import { EventEmitter2 } from 'eventemitter2'

export const emitter = new EventEmitter2()

export const emitPayablesReload = () => {
  emitter.emit('payables_reload')
}
export const onPayablesReload = (callback: () => void) => {
  emitter.on('payables_reload', callback)
}
export const offPayablesReload = (callback: () => void) => {
  emitter.off('payables_reload', callback)
}

export const emitReceivableInvoicesReload = () => {
  emitter.emit('receivable_incoices_reload')
}
export const onReceivableInvoicesReload = (callback: () => void) => {
  emitter.on('receivable_incoices_reload', callback)
}
export const offReceivableInvoicesReload = (callback: () => void) => {
  emitter.off('receivable_incoices_reload', callback)
}

export const emitReceivablesReload = () => {
  emitter.emit('receivables_reload')
}
export const onReceivablesReload = (callback: () => void) => {
  emitter.on('receivables_reload', callback)
}
export const offReceivablesReload = (callback: () => void) => {
  emitter.off('receivables_reload', callback)
}

export const emitDocsAndReportsReload = () => {
  emitter.emit('docs_and_reports_reload')
}
export const emitDashboardReload = () => {
  emitter.emit('dashboard_reload')
}
export const onDashboardReload = (callback: () => void) => {
  emitter.on('dashboard_reload', callback)
}
export const offDashboardReload = (callback: () => void) => {
  emitter.off('dashboard_reload', callback)
}

export const emitInboxReload = () => {
  emitter.emit('inbox_reload')
}
export const onInboxReload = (callback: () => void) => {
  emitter.on('inbox_reload', callback)
}
export const offInboxReload = (callback: () => void) => {
  emitter.off('inbox_reload', callback)
}

export const emitDialogPaymentApprovalsInfo = (transferId: string) => {
  emitter.emit('dialog_payment_approvals_info', transferId)
}
export const onDialogPaymentApprovalsInfo = (callback: () => void) => {
  emitter.on('dialog_payment_approvals_info', callback)
}
export const offDialogPaymentApprovalsInfo = (callback: () => void) => {
  emitter.off('dialog_payment_approvals_info', callback)
}

export const emitAccountingSyncFinished = () => {
  emitter.emit('accounting_sync_finished')
}

export const emitIntegrationSyncFinished = () => {
  emitter.emit('integration_sync_finished')
}
export const onIntegrationSyncFinished = (callback: () => void) => {
  emitter.on('integration_sync_finished', callback)
}
export const offIntegrationSyncFinished = (callback: () => void) => {
  emitter.off('integration_sync_finished', callback)
}

export const onAccountingSyncFinished = (callback: () => void) => {
  emitter.on('accounting_sync_finished', callback)
}
export const offAccountingSyncFinished = (callback: () => void) => {
  emitter.off('accounting_sync_finished', callback)
}
export const emitterEvents = {
  featureUpsell: 'feature_upsell',
}
